// extracted by mini-css-extract-plugin
module.exports = {"panelContainer":"InquiryWizardStepSpecies_panelContainer__2EuhK","speciesCheckBoxGroup":"InquiryWizardStepSpecies_speciesCheckBoxGroup__1tL7d"};